<template>
  <div>
    <sp-360-panel :title="header" titleOnImage :showSubImage="true" :subImage="idSub" footerText="" id="Raio-x">
      <div class="divComboTab" style="padding-top: 2%; padding-bottom: 1%;">
        <div class="flex ">
          <multiselect id="selectSubprefeituras" name="Subprefeituras" placeholder="Selecione uma Subprefeitura"
            track-by="nome" label="nome" :value="subSel" :options="subs" :close-on-select="true" :show-labels="false"
            @input="updateMultiSelect" />
        </div>
        <div>
          <va-tabs right grow v-model="tabValue">
            <va-tab v-for="tabObject in tabObjects" :key="tabObject.key" v-on:tabClick="tabClick()">
              {{tabObject.title}}
            </va-tab>
          </va-tabs>
        </div>
      </div>
      <div class="flex-box row" id="raioX">
        <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP" :habilitarAnimacaoClique="true" :habilitarLegenda='false'>
        </sp-map>
        <div id="tabs-Segmentos" class="segmento">
          <div id="saude" v-show="tabValue === 0">
              <div id="cards" class="topCardGrid">
                  <sp-card :valor="ubs.total" :descricao="ubs.subgrupo" classDesc="pull-right" :lgGrid="3" :mdGrid="3"
                    stripe='success' icon="fa fa-medkit boldness cor1" />
                  <sp-card :valor="espec.total" :descricao="espec.subgrupo" classDesc="pull-right" :lgGrid="3"
                    :mdGrid="3" stripe='success' icon="fa fa-blind boldness cor1" />
                  <sp-card :valor="ama.total" :descricao="ama.subgrupo" classDesc="pull-right" :lgGrid="3" :mdGrid="3"
                    stripe='success' icon="fa fa-stethoscope boldness cor1" />
                  <sp-card :valor="hosp.total" :descricao="hosp.subgrupo" classDesc="pull-right" :lgGrid="3" :mdGrid="3"
                    stripe='success' icon="fa fa-hospital-o boldness cor1" />
              </div>
              <div id="lists" class="row flex">
                <div class="flex ">
                  <sp-360-panel :title="$t('raiox.saude.chart-titulo')" :footerText="refSMS">
                      <div id="chartMedicamentos"/>
                  </sp-360-panel>
                </div>
                <div class="flex ">
                  <sp360-list :title="$t('raiox.saude.list-titulo')" :footerText="refSMS">
                    <template v-for="(m, index) in listaFilaExame" class="list listas">
                      <va-item>
                        <va-item-section>
                          <va-item-label>
                            {{ "#"+ (index+1) + " - " +   m.subgrupo}}
                          </va-item-label>
                          <va-item-label caption>
                            Procedimentos na fila : {{m.total.toLocaleString('pt-BR')}} |  {{ m.percentual}}
                          </va-item-label>
                        </va-item-section>
                      </va-item>
                      <va-list-separator v-if="index < listaFilaExame.length-1" />
                    </template>
                  </sp360-list>
                </div>
              </div>
              <div id="table" class="row flex">
                <div class="flex lg12 md12 sm12">
                  <sp-360-panel :title="$t('raiox.saude.tabela-titulo')" :footerText="refSMS">
                    <sp360-data-table id="tabelaEstoqueMedicamentos" ref="tabelaEstoqueMedicamentos"
                    :data="tabelaMedicamentos.data"
                    :fields="tabelaMedicamentos.tableFields"
                    :perPage="tabelaMedicamentos.itemsPerPage"
                    :onEachSide="tabelaMedicamentos.onEachSide"
                    :sortFunctions="tabelaMedicamentos.sortFunctions"
                    :rowClass="corRowPorPorcentagem"
                    :striped="false"
                    />
                  </sp-360-panel>
                </div>
              </div>
          </div>
          <div id="educacao" v-show="tabValue === 1">
            <!-- <div class="row" id="equipamentos">
                <div class="col oddCards"> -->
            <div id="equipamentos" class="topCardGrid">
                  <sp-card :valor="total_equipamentos" :descricao="$t('raiox.educacao.card-equipamento-desc')" icon="fa fa-university boldness cor1" classDesc="pull-right" :mdGrid="12" :lgGrid="12"/>
                  <sp-card :valor="total_creches" :descricao="$t('raiox.educacao.card-creche-desc')"  icon="glyphicon glyphicon-baby-formula boldness cor1" classDesc="pull-right" :mdGrid="12" :lgGrid="12"/>
                  <sp-card :valor="total_emefs" :descricao="$t('raiox.educacao.card-emef-desc')"  icon="fa fa-book boldness cor1" classDesc="pull-right" :mdGrid="12" :lgGrid="12"/>
                  <sp-card :valor="total_ceus" :descricao="$t('raiox.educacao.card-ceu-desc')"  icon="fa fa-graduation-cap boldness cor1" classDesc="pull-right" :mdGrid="12" :lgGrid="12"/>
                  <sp-card :valor="total_emeis" :descricao="$t('raiox.educacao.card-emei-desc')"  icon="fa fa-child boldness cor1" classDesc="pull-right" :mdGrid="12" :lgGrid="12"/>
            </div>
            <div class="flex-box" id="charts">
                <div class="flex-box_item_chart flex">
                  <sp-360-panel :title="$t('eixos.social.bottomPanels.crecheChart')" :footerText="refSME">
                      <div id="chartMatriculas"/>
                  </sp-360-panel>
                </div>
                <div id="cardVertical"  class="flex-box_item_cards">
                  <sp-card :valor="TotalFilaCreche" :descricao="$t('raiox.educacao.card-fila-creche-desc')" :valorProgressBar="percentualFilaDaCreche(TotalFilaCreche)" :mdGrid="12" :lgGrid="12"/>
                  <sp-card :valor="redeDireta" :descricao="$t('raiox.educacao.card-matricula-creche-direta-desc')" :valorProgressBar="percentualMetriculas(redeDireta)" :mdGrid="12"  :lgGrid="12"/>
                  <sp-card :valor="redeIndireta" :descricao="$t('raiox.educacao.card-matricula-creche-indireta-desc')" :valorProgressBar="percentualMetriculas(redeIndireta)" :mdGrid="12"  :lgGrid="12"/>
                  <sp-card :valor="redeParceira" :descricao="$t('raiox.educacao.card-matricula-creche-parceira-desc')" :valorProgressBar="percentualMetriculas(redeParceira)" :mdGrid="12"  :lgGrid="12"/>
                </div>
            </div>
          </div>
          <div id="sp156" v-show="tabValue === 2">
            <div class="row">
              <div class="flex md16 lg12 sm12">
                <sp-360-panel :title="$t('raiox.zeladoria.tabela.titulo')" :footerText="refSMIT">
                  <sp360-data-table id="tabelaZeladoria" ref="tabelaZeladoria"
                  :data="tabelaServicos.tableData.data"
                  :fields="tabelaServicos.tableFields"
                  :perPage="tabelaServicos.itemsPerPage"
                  :onEachSide="tabelaServicos.onEachSide"
                  :sortFunctions="tabelaServicos.sortFunctions"
                  :striped="true"
                  />
                </sp-360-panel>
              </div>
            </div>
          </div>
          <div id="demografia" v-show="tabValue === 3">
            <div id="cards" class="topCardGrid">
                <sp-card :valor="populacaoRegionalCard()" :descricao="$t('raiox.demografia.card-desc.habitantes')" :valorProgressBar="percentualPopulacional(populacaoRegional, populacaoMunicipal.t)" classDesc="pull-right" :lgGrid="4" :mdGrid="4"
                  stripe='success'  :footerText="refPOP"/>
                <sp-card :valor="populacaoFemininaCard()" :descricao="$t('raiox.demografia.card-desc.feminino')" :valorProgressBar="percentualPopulacional(populacaoFeminina, populacaoRegional)" classDesc="pull-right" :lgGrid="4" :mdGrid="4"
                  stripe='success' :footerText="refPOP"/>
                <sp-card :valor="populacaoMasculinaCard()" :descricao="$t('raiox.demografia.card-desc.masculino')" :valorProgressBar="percentualPopulacional(populacaoMasculina, populacaoRegional)" classDesc="pull-right" :lgGrid="4" :mdGrid="4"
                  stripe='success' :footerText="refPOP"/>
            </div>
            <div id="painel" class="row flex">
              <div id="piramide" class="flex md16 lg12 sm12">
                <sp-360-panel :title="demografiaTitulo" :footerText="refPOP">
                  <div class="chart">
                    <grafico-piramide :dados='dadosGraficoDemografia' ref="graficoRegional" :footerText="refPOP"/>
                  </div>
                </sp-360-panel>
              </div>
            </div>
          </div>
          <!--div id="assistenciaSocial" v-show="tabValue === 4"-->
          <div id="assistenciaSocial" v-show="false">
            <div id="cards" class="topCardGrid">
                <sp-card :valor="dadosSegmentoAssistenciaSocial.cards.ocupacao"
                  :descricao="$t('raiox.assistencia.card-desc.ocupacaoMedia')"
                  icon="fa fa-tachometer boldness" classDesc="pull-right"
                  stripe='success'
                  />
                <sp-card :valor="dadosSegmentoAssistenciaSocial.cards.vagas"
                  :descricao="$t('raiox.assistencia.card-desc.numeroVagas')"
                  icon="fa fa-hotel boldness"
                  classDesc="pull-right"
                  stripe='success'
                  />
                <sp-card :valor="dadosSegmentoAssistenciaSocial.cards.populacao"
                  :descricao="$t('raiox.assistencia.card-desc.populacaodeRua')"
                  icon="fa fa-users boldness"
                  classDesc="pull-right"
                  stripe='success'
                  />
            </div>
            <div id="painel" class="row flex">
              <!-- <div id="abrigos" class="flex md6 lg6 sm12">
                <sp-360-panel :title="$t('raiox.assistencia.painel.abrigos.titulo')">
                    <div id="chartOcupacaoAbrigos"/>
                </sp-360-panel>
              </div> -->
              <div id="servicos" class="flex ">
                <sp-360-panel :title="servicosRegiao">
                    <!-- <sp-360-chart :dados='dadosServicos' :options='optionsServicos' ref="graficoServicos"/> -->
                    <sp360-data-table id="tabelaOrgaos" ref="tabelaServicosAssistenciaSocial"
                      :data="dadosSegmentoAssistenciaSocial.dadosRegionalizados.dados"
                      :fields="dadosSegmentoAssistenciaSocial.dadosRegionalizados.campos"
                      :perPage="dadosSegmentoAssistenciaSocial.dadosRegionalizados.itemsPerPage"
                      :onEachSide="dadosSegmentoAssistenciaSocial.dadosRegionalizados.onEachSide"
                      :dataModeFilterableFields="dadosSegmentoAssistenciaSocial.dadosRegionalizados.filtros"
                      :sortFunctions="dadosSegmentoAssistenciaSocial.dadosRegionalizados.sortFunctions" />
                </sp-360-panel>
              </div>
            </div>
          </div>

          <div id="singularidades" v-show="tabValue === 4">
            <div id="painel_singularidades" class="flex">

              <sp-360-panel v-if="dadosSingularidades['historiaNome']" :title="$t('raiox.singularidades.paineis.historia')" class="flex lg6 ma-1">
                <p>{{ dadosSingularidades['historiaNome'] }}</p>
              </sp-360-panel>

              <sp-360-panel v-if="dadosSingularidades['surgimento']" :title="$t('raiox.singularidades.paineis.surgimento')" class="flex lg6 ma-1">
                <p>{{ dadosSingularidades['surgimento'] }}</p>
              </sp-360-panel>

              <sp-360-panel v-if="dadosSingularidades['povoamento']" :title="$t('raiox.singularidades.paineis.povoamento')" class="flex lg6 ma-1">
                <p>{{ dadosSingularidades['povoamento'] }}</p>
              </sp-360-panel>

              <sp-360-panel v-if="dadosSingularidades['transporte']" :title="$t('raiox.singularidades.paineis.transporte')" class="flex lg6 ma-1">
                <p>{{ dadosSingularidades['transporte'] }}</p>
              </sp-360-panel>

              <sp-360-panel v-if="dadosSingularidades['desenvolvimento']" :title="$t('raiox.singularidades.paineis.desenvolvimento')" class="flex lg6 ma-1">
                <p>{{ dadosSingularidades['desenvolvimento'] }}</p>
              </sp-360-panel>

              <sp-360-panel v-if="dadosSingularidades['geral']" :title="$t('raiox.singularidades.paineis.geral')" class="flex lg6 ma-1">
                <p>{{ dadosSingularidades['geral'] }}</p>
              </sp-360-panel>

            </div>
          </div>
        </div>
      </div>
    </sp-360-panel>
  </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpCard from '@/components/ui/cards/SP360Card'
import SpMap from '@/components/maps/360-maps/SPMap'
import distritos from '@/components/maps/360-maps/SPDistritos'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Multiselect from 'vue-multiselect'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import am4lang_pt_BR from '@amcharts/amcharts4/lang/pt_BR'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360List from '@/components/ui/list/VaList'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import GraficoPiramide from '@/components/statistics/charts/GraficoPiramide'
import SubImagens from '@/components/dashboard/raiox/SubImagens'

export default {
  name: 'raiox',
  mixins: [],
  components: { SpMap, SpCard, distritos, Multiselect, Sp360Panel, Sp360DataTable, Sp360List, Sp360Chart, GraficoPiramide, SubImagens, MethGlob },
  computed: {
    header: function () {
      return 'Raio-X : ' + (this.subSelecionada || 'São Paulo')
    },
    header2: function () {
      return (this.headerx || 'São Paulo')
    },
    demografiaTitulo: function () {
      return 'Distribuição Etaria : ' + (this.subSelecionada || 'São Paulo')
    },
    servicosRegiao: function () {
      return 'Serviços oferecidos : ' + (this.subSelecionada || 'São Paulo')
    },
  },

  data () {
    return {
      // Objetos dos Seletores e Filtros
      tabValue: 0, // <- Altere esse valor para mudar a guia inicial. OBS : Não Altera a ordem das opções somente a guia inicialmente carregada.  DEBUG
      tabObjects: [
        {
          key: 'Saude',
          title: 'Saúde',
          tabValue: 0,
        },
        {
          key: 'Educação',
          title: 'Educação',
          tabValue: 1,
        },
        {
          key: 'Zeladoria',
          title: 'Zeladoria',
          tabValue: 2,
        },
        {
          key: 'Demografia',
          title: 'Demografia',
          tabValue: 3,
        },
        /* {
          key: 'Assistencia',
          title: 'Assistência Social',
        }, */
        {
          key: 'Singularidades',
          title: 'Singularidades',
          tabValue: 4,
        },
      ],
      subs: [],
      subSelecionada: null,
      subSel: '',
      // ------------------------

      // Objetos de Dados dos Segmentos
      dadosSegmentoSaude: {},
      dadosSegmentoEducacao: {},
      dadosSegmentoZeladoria: {},
      dadosSegmentoDemografia: {},
      dadosSegmentoSingularidades: {},
      dadosSegmentoDemandaRegional: [],
      dadosSegmentoAssistenciaSocial: {},
      // --------------------------

      // Dados - Saude
      chartMedicamento: {},
      filaClinicos: 0,
      filaDiagnosticos: 0,
      filaExames: 0,

      listaFilaExame: [],
      listaFarmacais: [],
      listaUnidadesSaude: [],
      saudeChart: {},
      saudeChartOptions: {},
      footerFarmacias: 'Rodapé',
      ubs: { subgrupo: 'UBS', total: 0 },
      espec: { subgrupo: 'Centros Especializados', total: 0 },
      ama: { subgrupo: 'AMAs', total: 0 },
      hosp: { subgrupo: 'Hospitais', total: 0 },
      tabelaMedicamentos: {
        titulo: 'Informações do Estoque das Farmacias da Rede',
        data: [],
        tableFields: [{
          name: 'unidade',
          sortField: 'unidade',
          title: 'Unidade',
          width: '50%',
        },
        {
          name: 'cmm',
          sortField: 'cmm',
          title: 'Consumo Medio Mensal',
          width: '25%',
          callback: MethGlob.thousandSeparator,
        },
        {
          name: 'perc_estoque',
          sortField: 'perc_estoque',
          title: 'Estoque Medicamentos (%)',
          width: '25%',
          callback: function (x) { return MethGlob.formataPercentual(x) },
        }],
        sortFunctions: {
          'perc_estoque': MethGlob.ordenaTabelaParseFloat,
          'cmm': MethGlob.ordenaTabelaParseInt,
          'unidade': MethGlob.ordenaTabela,
        },
        onEachSide: 1,
        topTooltipOptions: {},
        itemsPerPage: 5,
      },
      coresTabela: [],
      // --------------------------

      // Dados - Educação
      chartEducacao: {},
      TotalMatricula: null,
      TotalFilaCreche: null,
      redeDireta: null,
      redeIndireta: null,
      redeParceira: null,
      total_equipamentos: 0,
      total_creches: 0,
      total_emefs: 0,
      total_emeis: 0,
      total_ceus: 0,
      piechartdeficitcreche: {},
      piechartdeficitcrecheOptions: {},
      filaCrecheche: {},
      // --------------------------

      // Dados - Zeladoria
      listaServicos: [],
      tabelaServicos: {
        titulo: 'raiox.zeladoria.tabela.titulo',
        tableData: {
          'data': [],
        },
        tableFields: [{
          name: 'servico_desc',
          sortField: 'servico_desc',
          title: 'Serviço',
        },
        {
          name: 'recebidas',
          sortField: 'recebidas',
          title: 'Solicitações Recebidas',
          callback: MethGlob.thousandSeparator,
        },
        {
          name: 'finalizadas',
          sortField: 'finalizadas',
          title: 'Solicitações Concluídas',
          callback: MethGlob.thousandSeparator,
        },
        {
          name: 'media_atendimento_dias',
          sortField: 'media_atendimento_dias',
          title: 'Tempo Médio de Atendimento',
          callback: function (x) {
            return (x > 1) ? x.toLocaleString('pt-BR') + ' dias' : x.toLocaleString('pt-BR') + ' dia'
          },
        },
        ],
        onEachSide: 1,
        sortFunctions: {
          'recebidas': MethGlob.ordenaTabelaParseInt,
          'finalizadas': MethGlob.ordenaTabelaParseInt,
          'media_atendimento_dias': MethGlob.ordenaTabelaParseInt,
          'servico_desc': MethGlob.ordenaTabela,
        },
        topTooltipOptions: {},
        itemsPerPage: 20,
      },
      // --------------------------

      // Dados - Demografia
      demografiaCores: [],
      dadosGraficoDemografia: [],
      populacaoMunicipal: {},
      populacaoMasculina: 0,
      populacaoFeminina: 0,
      populacaoRegional: 0,
      // --------------------------

      // Dados - Singularidades
      dadosSingularidades: {},
      idSub: 0,
      // --------------------------

      // Dados - Assistencia Social
      dadosSegmentoAssistenciaSocial: {
        ocupacaoAbrigos: 0,
        dadosRegionalizados: {
          dados: [],
          campos: [{

            // media_vagas_disponiveis: (...)
            // media_vagas_ocupadas: (...)
            // percentual_medio_ocupacao: (...)
            // total_vagas_reais: (...)

            name: 'tipo_servico',
            sortField: 'tipo_servico',
            title: this.$t('raiox.assistencia.painel.servicos.tipo_servico'),
            width: '50%',
            // callback: function (value) { return MethGlob.abreviarOrgaos(value) },
          }, {
            name: 'total_vagas_contratadas',
            sortField: 'total_vagas_contratadas',
            title: this.$t('raiox.assistencia.painel.servicos.total_vagas_contratadas'),
            callback: function (value) { return value.toLocaleString('pt-BR') },
            width: '10%',
          }, {
            name: 'total_vagas_femininas',
            sortField: 'total_vagas_femininas',
            title: this.$t('raiox.assistencia.painel.servicos.total_vagas_femininas'),
            callback: function (value) { return value.toLocaleString('pt-BR') },
            width: '10%',
          }, {
            name: 'total_vagas_masculinas',
            sortField: 'total_vagas_masculinas',
            title: this.$t('raiox.assistencia.painel.servicos.total_vagas_masculinas'),
            callback: function (value) { return value.toLocaleString('pt-BR') },
            width: '10%',
          }, {
            name: 'percentual_medio_ocupacao',
            sortField: 'percentual_medio_ocupacao',
            title: this.$t('raiox.assistencia.painel.servicos.percentual_medio_ocupacao'),
            callback: function (value) { return value.toLocaleString('pt-BR') + '%' },
            width: '10%',
          },
          ],
          filtros: ['cargo'],
          sortFunctions: {
            'cargo': MethGlob.ordenaTabela,
            'total_pessoas': MethGlob.ordenaTabelaParseInt,
            'soma_vencimento_cargo': MethGlob.ordenaTabelaParseFloat,
            'media_vencimento_cargo': MethGlob.ordenaTabelaParseFloat,
          },
          onEachSide: 1,
          topTooltipOptions: {},
          itemsPerPage: 10,
        },
        cards: {
          ocupacao: 0,
          vagas: 0,
          populacao: 0,
        },
      },
      // --------------------------

      refSMS: '',
      refSME: '',
      refSMIT: '',
      refPOP: '',

      // .................
    }
  },

  created () {
    Promise.all([
      this.$store.dispatch('servicosSME/buscarRedeEnsino', { agrupamento: 'POR_SUBPREFEITURA' }),
      this.$store.dispatch('servicosSME/buscarFilaCreche', { intervalo: 'MAIS_RECENTE' }),
      this.$store.dispatch('populacao/buscarPopulacaoPorIdadeSexo'),
      this.$store.dispatch('saude/buscarEstoqueDeRemediosPorUnidade'),
      this.$store.dispatch('saude/buscarFilaDeExameProcedimentoPorSubgrupoPorRegiao', { tipoProcedimento: 'DIAGNOSTICO' }),
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST, intervalo: 'ULTIMO_MES', filtroId: '952,1071,2655,2641,927,938,939,951' }),
      this.$store.dispatch('servicosSME/buscarRedeEnsino', { agrupamento: 'NENHUM' }),
      this.$store.dispatch('regiao/buscarSingularidades'),
      this.$store.dispatch('saude/buscarUnidadesRedeMunicipalPorGrupo'),
      this.$store.dispatch('assistenciaSocial/buscarVagasAcolhimentoConsolidadoUltimoMes'),
      this.$store.dispatch('assistenciaSocial/buscarVagasAcolhimentoPorSubprefeituraNoUltimoMes'),
    ]).then((response) => {
      this.refSME = this.$t('rodape.fonteData', { fonte: response[0].sigla_orgao + '-' + response[0].fonte, data: new Date(response[0].data_referencia_dado).toLocaleDateString('pt-BR') })
      this.refSMS = this.$t('rodape.fonteData', { fonte: response[4].data.sigla_orgao + '-' + response[4].data.fonte, data: new Date(response[4].data.data_referencia_dado).toLocaleDateString('pt-BR') })
      this.refSMIT = this.$t('rodape.fonteData', { fonte: response[5].data.sigla_orgao + '-' + response[5].data.fonte, data: new Date(response[5].data.data_referencia_dado).toLocaleDateString('pt-BR') })
      this.refPOP = this.$t('rodape.fonteData', { fonte: response[2].data.sigla_orgao, data: new Date(response[2].data.data_referencia_dado).toLocaleDateString('pt-BR') })

      this.subs = _.orderBy(SPMapaNomes.slice(1), 'nome')
      this.dadosSegmentoSaude = { remediosPorUnidade: response[3].data.data, filadeExames: response[4].data.data, unidadesSaude: response[8].data.data }
      this.dadosSegmentoEducacao = { redeEnsino: response[0].data, filaCreche: response[1].data, equipamentos: response[6].data }
      this.dadosSegmentoZeladoria = { servicos156: response[5].data.data }
      this.dadosSegmentoDemografia = { populacao: response[2].data.data }
      this.dadosSegmentoSingularidades = { singularidades: response[7].data.data }
      this.demografiaCores = [
        CorUtils.getCorPorNomeSp360('verde-limao-medio'),
        CorUtils.getCorPorNomeSp360('amarelo-bistre-medio'),
        CorUtils.getCorPorNomeSp360('azul-columbia-medio'),
        CorUtils.getCorPorNomeSp360('azul-glauco-medio'),
      ]
      this.coresTabela = [
        CorUtils.getCorPorNomeSp360(CorUtils.VERMELHO_MEDIO),
        CorUtils.getCorPorNomeSp360(CorUtils.AMARELO_MEDIO),
        CorUtils.getCorPorNomeSp360(CorUtils.VERDE_MEDIO),
        CorUtils.getCorPorNomeSp360(CorUtils.AZUL_GLAUCO_ESCURO),
      ]

      this.dadosSegmentoAssistenciaSocial.ocupacaoAbrigos = response[9].data.data[0]
      this.dadosSegmentoAssistenciaSocial.dadosRegionalizados.massa = response[10].data.data
      this.dadosSegmentoAssistenciaSocial.dadosRegionalizados.dados = response[10].data.data

      this.dadosSegmentoAssistenciaSocial.cards = {
        ocupacao: response[9].data.data[0].percentual_medio_ocupacao + '%',
        vagas: response[9].data.data[0].total_vagas_contratadas,
        populacao: response[9].data.data[0].total_pessoas,
      }

      this.updateDashBoard()
    })
  },

  mounted () {},

  beforeDestroy () {
    am4core.disposeAllCharts()
  },

  methods: {
    updateMultiSelect (value) {
      if (!value) { // false
        value = this.subSel // use o ultimo selecionado
      }
      this.filtrarPorRegiao('sub' + value.id)
    },

    tabClick () {
      this.refreshDashboard(this.ultimoClickIdSub)
    },

    // TODO : Refatorar
    filtrarPorRegiao (id) {
      let idNum = MethGlob.idSvgToNumeric(id)
      if (this.ultimoClickNomeSub !== id) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub, true)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
        this.subSelecionada = this.$refs.mapa.nomes[idNum].nome
        this.$refs.mapa.emulateClick(id)
        this.$refs.mapa.pintarRegiao(id, CorUtils.getCorPorNomeSp360(CorUtils.VERDE_MEDIO))
        this.refreshDashboard(idNum)
      } else {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub, true)
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        this.subSelecionada = null
        this.refreshDashboard()
      }
      this.subSel = _.find(this.subs, (e) => { return e.nome === this.subSelecionada })
    },

    updateDashBoard (id) {
      // AMCHARTS

      this.segmentSaudeUpdate(id)
      this.segmentEducacaoUpdate(id)
      this.segmentZeladoriaUpdate(id)
      this.segmentDemografiaUpdate(id)
      this.segmentSingularidadesUpdate(id)
      this.segmentAssistenciaUpdate(id)
    },

    filtrarPorDistrito (id) {
      this.$refs.dist.filtrar(id)
    },

    refreshDashboard (id) {
      this.segmentSaudeRefresh(id)
      this.segmentEducacaoRefresh(id)
      this.segmentZeladoriaUpdate(id)
      this.segmentDemografiaUpdate(id)
      this.segmentSingularidadesUpdate(id)
      this.segmentAssistenciaUpdate(id)
      this.chartMedicamento.invalidateData()
      this.chartEducacao.invalidateData()
    },
    /**  Metodos do Segmento de Saude
    */

    segmentSaudeUpdate (id) {
      this.populateTabelaFilaExame(id)
      this.populateTabelaUnidadesSaude(id)
      this.pupulateTabelaFarmacia(id)
      this.populateMedicamentoChart(id)
    },

    segmentSaudeRefresh (id) {
      this.populateTabelaFilaExame(id)
      this.populateTabelaUnidadesSaude(id)
      this.pupulateTabelaFarmacia(id)
      this.refreshMedicamentoChart(id)
    },

    populatePrazoPieChart () {
      this.prazoPieChartData = {}
      this.prazoPieChartData.labels = [this.$t('resumo.labelForaPrazo'), this.$t('resumo.labelDentroPrazo')]
      this.prazoPieChartData.datasets = []
      let dataset = {
        backgroundColor: ['#FFCC22', '#33AADD'],
        data: [this.ultimoMes.finalizadas_fora_prazo, this.ultimoMes.finalizadas_dentro_prazo],
      }
      this.prazoPieChartData.datasets.push(dataset)
    },

    populateTabelaUnidadesSaude (sub) {
      let redeSub = sub ? _.filter(this.dadosSegmentoSaude.unidadesSaude, { 'id_sub': sub }) : this.dadosSegmentoSaude.unidadesSaude
      let ubs = 0
      let espec = 0
      let ama = 0
      let hosp = 0
      let estoque = 0

      redeSub.forEach(e => {
        ubs += (e.grupo === 'UBS') ? 1 : 0
        espec += (e.grupo === 'ESPEC') ? 1 : 0
        ama += (e.grupo === 'AMA') ? 1 : 0
        hosp += (e.grupo === 'HOSPITAL') ? 1 : 0
        estoque += e.perc_estoque || 0
      })

      this.PorcentagemEstoque = MethGlob.formataPercentual((estoque / redeSub.length))

      this.ubs.total = ubs
      this.espec.total = espec
      this.ama.total = ama
      this.hosp.total = hosp
    },

    populateTabelaFilaExame (sub) {
      let dados = []
      let redeSub = sub ? _.find(this.dadosSegmentoSaude.filadeExames, { 'id_subprefeitura': sub }) : this.dadosSegmentoSaude.filadeExames[0]

      for (let i = 0; i < redeSub.lista_subgrupos.length; i++) {
        dados.push({
          subgrupo: redeSub.lista_subgrupos[i].subgrupo,
          total: redeSub.lista_subgrupos[i].total || 0,
          percentual: MethGlob.formataPercentual((redeSub.lista_subgrupos[i].total / this.dadosSegmentoSaude.filadeExames[0].lista_subgrupos[i].total) * 100),
        })
      }

      // redeSub.lista_subgrupos.forEach(e => {
      //   dados.push({
      //     subgrupo: e.subgrupo,
      //     total: e.total || 0,
      //     percentual : e.total / this.dadosSegmentoSaude.filadeExames[0]
      //   })
      // })

      this.listaFilaExame = dados
    },

    pupulateTabelaFarmacia (sub) {
      this.dadosSegmentoSaude.remediosPorUnidade = _.orderBy(this.dadosSegmentoSaude.remediosPorUnidade, ['cmm'], ['asc'])
      let redeSub = sub ? _.filter(this.dadosSegmentoSaude.remediosPorUnidade, { 'id_sub': sub }) : this.dadosSegmentoSaude.remediosPorUnidade
      this.listaFarmacais = redeSub
      this.$set(this.tabelaMedicamentos, 'data', this.listaFarmacais)
    },

    estoqueFarmacias (m) {
      return 'Consumo Medio Mensal: ' + m.cmm + ' unidades | Percentual Estoque: ' + m.perc_estoque
    },

    refreshMedicamentoChart (id) {
      let unidades = id ? _.filter(this.dadosSegmentoSaude.remediosPorUnidade, { 'id_sub': id }) : this.dadosSegmentoSaude.remediosPorUnidade
      let sub = this.calcularRangeCriticidadeETotalizador(unidades)
      this.chartMedicamento.data = []
      if (sub[0][0].quantidade > 0) {
        this.chartMedicamento.data.push({
          'categoria': 'Critico',
          'percentual': sub[0][0].quantidade,
          'color': am4core.color(this.coresTabela[0]),
        })
      }
      if (sub[0][1].quantidade > 0) {
        this.chartMedicamento.data.push({
          'categoria': 'Regular',
          'percentual': sub[0][1].quantidade,
          'color': am4core.color(this.coresTabela[1]),
        })
      }
      if (sub[0][2].quantidade > 0) {
        this.chartMedicamento.data.push({
          'categoria': 'Bom',
          'percentual': sub[0][2].quantidade,
          'color': am4core.color(this.coresTabela[2]),
        })
      }
      if (sub[0][3].quantidade > 0) {
        this.chartMedicamento.data.push({
          'categoria': 'Ideal',
          'percentual': sub[0][3].quantidade,
          'color': am4core.color(this.coresTabela[3]),
        })
      }
    },

    populateMedicamentoChart (id) {
      let unidades = id ? _.filter(this.dadosSegmentoSaude.remediosPorUnidade, { 'id_sub': id }) : this.dadosSegmentoSaude.remediosPorUnidade
      let sub = this.calcularRangeCriticidadeETotalizador(unidades)

      if (typeof this.chartMedicamento.dispose === 'function') {
        this.chartMedicamento.dispose()
      }

      am4core.useTheme(am4themes_animated)
      am4core.ready(() => {
        let chart = am4core.create('chartMedicamentos', am4charts.PieChart)
        chart.language.locale['_decimalSeparator'] = ','
        chart.language.locale['_thousandSeparator'] = '.'

        let grupos = [{
          'categoria': 'Critico',
          'percentual': sub[0][0].quantidade,
          'color': am4core.color(this.coresTabela[0]),
        }, {
          'categoria': 'Regular',
          'percentual': sub[0][1].quantidade,
          'color': am4core.color(this.coresTabela[1]),
        }, {
          'categoria': 'Bom',
          'percentual': sub[0][2].quantidade,
          'color': am4core.color(this.coresTabela[2]),
        }, {
          'categoria': 'Ideal',
          'percentual': sub[0][3].quantidade,
          'color': am4core.color(this.coresTabela[3]),
        }]

        grupos.forEach(e => {
          if (e.percentual > 0) {
            chart.data.push(e)
          }
        })

        let pieSeries = chart.series.push(new am4charts.PieSeries())
        pieSeries.dataFields.value = 'percentual'
        pieSeries.dataFields.category = 'categoria'

        // Let's cut a hole in our Pie chart the size of 30% the radius
        chart.innerRadius = am4core.percent(30)

        // Put a thick white border around each Slice

        pieSeries.ticks.template.disabled = false
        pieSeries.alignLabels = true
        pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%"
        pieSeries.labels.template.radius = am4core.percent(10)
        pieSeries.labels.template.fill = am4core.color('black')

        pieSeries.slices.template.stroke = am4core.color('#fff')
        pieSeries.slices.template.strokeWidth = 2
        pieSeries.slices.template.strokeOpacity = 1
        pieSeries.slices.template.propertyFields.fill = 'color'
        pieSeries.slices.template.cursorOverStyle = [
          {
            'property': 'cursor',
            'value': 'pointer',
          },
        ]
        chart.legend = new am4charts.Legend()
        chart.legend.labels.template.text = '{name} : {value} [/]'
        this.chartMedicamento = chart
      })
    },

    calcularRangeCriticidadeETotalizador (vetorDados) {
      let indices = [{ nome: this.$t('graficosSaude.critico'), quantidade: 0 }, { nome: this.$t('graficosSaude.regular'), quantidade: 0 }, { nome: this.$t('graficosSaude.bom'), quantidade: 0 }, { nome: this.$t('graficosSaude.ideal'), quantidade: 0 }]
      let totalizador = { total: 0, totalPerc: 0 }

      vetorDados.forEach((unidade) => {
        let percentual = parseFloat(unidade.perc_estoque)
        if (percentual >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.IDEAL) indices[3].quantidade++
        else if (percentual >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.BOM) indices[2].quantidade++
        else if (percentual >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.REGULAR) indices[1].quantidade++
        else indices[0].quantidade++
        totalizador.total++
        totalizador.totalPerc += unidade.perc_estoque
      })
      totalizador.totalPerc /= totalizador.total
      totalizador.totalPercClassificacao = this.getClassificadorPerc(totalizador.totalPerc)
      return [indices, totalizador]
    },

    getClassificadorPerc (perc) {
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.IDEAL) return 'Ideal'
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.BOM) return 'Bom'
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.REGULAR) return 'Regular'
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.CRITICO) return 'Crítico'
    },

    corRowPorPorcentagem (dataItem, index) {
      let val = parseFloat(dataItem.perc_estoque)
      if (val > Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.IDEAL) {
        return 'tabelaRemedioCorIdeal'
      } else if (val > Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.BOM) {
        return 'tabelaRemedioCorBom'
      } else if (val > Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.REGULAR) {
        return 'tabelaRemedioCorRegular'
      } else {
        return 'tabelaRemedioCorCritico'
      }
    },
    // -- fim Segmento de Saude

    /**  Metodos do Segmento de Educação
    */
    segmentEducacaoUpdate (id) {
      this.mostrarFilaCreche(id)
      this.populateMatriculas(id)
      this.populateRedeEnsino(id)
      this.filaCrechecheGeral(id)
      this.populatePiechartDeficitCreche(id)
    },

    segmentEducacaoRefresh (id) {
      this.mostrarFilaCreche(id)
      this.populateMatriculas(id)
      this.populateRedeEnsino(id)
      this.filaCrechecheGeral(id)
      this._refreshPiechartDeficitCreche(id)
      // this.populatePiechartDeficitCreche(id)
    },

    mostrarFilaCreche (sub) {
      let redeSub = sub ? _.filter(this.dadosSegmentoEducacao.filaCreche, { 'id_subprefeitura': sub }) : this.dadosSegmentoEducacao.filaCreche
      let total = 0

      redeSub.forEach(e => {
        total += (e.bercario_i || 0) + (e.bercario_ii || 0) + (e.mini_grupo_i || 0) + (e.mini_grupo_ii || 0)
      })
      this.TotalFilaCreche = total
    },

    populateMatriculas (sub) {
    },

    populateRedeEnsino (id) {
      this.total_equipamentos = 0
      this.total_creches = 0
      this.total_emefs = 0
      this.total_emeis = 0
      this.total_ceus = 0
      this.redeDireta = 0
      this.redeIndireta = 0
      this.redeParceira = 0
      let x = id ? _.filter(this.dadosSegmentoEducacao.equipamentos, { 'id_subprefeitura': id }) : this.dadosSegmentoEducacao.equipamentos
      x.forEach(e => {
        this.total_equipamentos += 1
        this.total_creches += this.__contarCreche(e)
        this.total_emefs += this.__contarEMEF(e)
        this.total_emeis += this.__contarEMEI(e)
        this.total_ceus += this.__contarCEU(e)
      })
      return x
    },

    __contarCreche (e) {
      switch (e.tipo) {
        case 'CECI':
        case 'CEMEI':
        case 'CCI/CIPS':
        case 'CEI DIRET':
          this.redeDireta += e.total_matriculas_creche
          return 1
        case 'CEI INDIR':
          this.redeIndireta += e.total_matriculas_creche
          return 1
        case 'CR.P.CONV':
        case 'ESC.PART.':
          this.redeParceira += e.total_matriculas_creche
          return 1
        default:
          return 0
      }
    },

    __contarEMEF (e) {
      switch (e.tipo) {
        case 'EMEFM':
        case 'EMEF':
          return 1
        default:
          return 0
      }
    },

    __contarEMEI (e) {
      switch (e.tipo) {
        case 'EMEI':
          return 1
        default:
          return 0
      }
    },

    __contarCEU (e) {
      switch (e.tipo) {
        case 'CEU EMEI':
        case 'CEU CEI':
        case 'CEU EMEF':
          return 1
        default:
          return 0
      }
    },

    filaCrechecheGeral () {
      this.filaCrecheche = { bercario_i: 0, bercario_ii: 0, mini_grupo_i: 0, mini_grupo_ii: 0, total: 0 }
      this.dadosSegmentoEducacao.filaCreche.forEach((sub) => {
        this.filaCrecheche.bercario_i += sub.bercario_i || 0
        this.filaCrecheche.bercario_ii += sub.bercario_ii || 0
        this.filaCrecheche.mini_grupo_i += sub.mini_grupo_i || 0
        this.filaCrecheche.mini_grupo_ii += sub.mini_grupo_ii || 0
      })
      this.filaCrecheche.total = (this.filaCrecheche.bercario_i + this.filaCrecheche.bercario_ii + this.filaCrecheche.mini_grupo_i + this.filaCrecheche.mini_grupo_ii)
      return this.filaCrecheche
    },

    percentualMetriculas (valor) {
      let a = (valor / (this.redeDireta + this.redeIndireta + this.redeParceira)) * 100
      return Math.round(a)
    },

    percentualFilaDaCreche (TotalFilaCreche) {
      let a = (TotalFilaCreche / this.filaCrecheche.total) * 100
      return parseInt(a.toFixed(2))
    },

    populatePiechartDeficitCreche (id) {
      let cores = []
      cores.push(CorUtils.getCorPorNomeSp360('verde-limao-medio'))
      cores.push(CorUtils.getCorPorNomeSp360('amarelo-bistre-medio'))
      cores.push(CorUtils.getCorPorNomeSp360('azul-columbia-medio'))
      cores.push(CorUtils.getCorPorNomeSp360('azul-glauco-medio'))
      cores = _.shuffle(cores)

      let sub = id ? _.find(this.dadosSegmentoEducacao.filaCreche, { 'id_subprefeitura': id }) : this.filaCrechecheGeral()
      /* Chart code */
      // Themes begin
      if (typeof this.chartEducacao.dispose === 'function') {
        this.chartEducacao.dispose()
      }
      am4core.useTheme(am4themes_animated)
      am4core.ready(() => {
        let chart = am4core.create('chartMatriculas', am4charts.PieChart)
        chart.language.intlLocales = 'pt-BR'
        chart.data = [{
          'grupo': this.$t('eixos.social.distribuicaoFilaCreche.deficitMenor1Ano'),
          'vagas': sub.bercario_i,
          'color': am4core.color(cores[0]),
        }, {
          'grupo': this.$t('eixos.social.distribuicaoFilaCreche.deficit1Ano'),
          'vagas': sub.bercario_ii,
          'color': am4core.color(cores[1]),
        }, {
          'grupo': this.$t('eixos.social.distribuicaoFilaCreche.deficit2Anos'),
          'vagas': sub.mini_grupo_i,
          'color': am4core.color(cores[2]),
        }, {
          'grupo': this.$t('eixos.social.distribuicaoFilaCreche.deficit3Anos'),
          'vagas': sub.mini_grupo_ii,
          'color': am4core.color(cores[3]),
        }]

        let pieSeries = chart.series.push(new am4charts.PieSeries())
        pieSeries.dataFields.value = 'vagas'
        pieSeries.dataFields.category = 'grupo'

        // Let's cut a hole in our Pie chart the size of 30% the radius
        chart.innerRadius = am4core.percent(30)

        // Put a thick white border around each Slice
        pieSeries.slices.template.stroke = am4core.color('#fff')
        pieSeries.slices.template.strokeWidth = 2
        pieSeries.slices.template.strokeOpacity = 1
        pieSeries.slices.template.propertyFields.fill = 'color'
        pieSeries.slices.template
          // change the cursor on hover to make it apparent the object can be interacted with
          .cursorOverStyle = [
            {
              'property': 'cursor',
              'value': 'pointer',
            },
          ]
        pieSeries.ticks.template.disabled = true
        pieSeries.alignLabels = false
        pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%"
        pieSeries.labels.template.radius = am4core.percent(-40)
        pieSeries.labels.template.fill = am4core.color('white')

        // Add a legend */
        chart.legend = new am4charts.Legend()
        chart.legend.labels.template.text = '{category}'
        chart.legend.labels.template.text = '{name} : {value} [/]'
        this.chartEducacao = chart
      })
    },

    _refreshPiechartDeficitCreche (id) {
      let cores = []
      cores.push(CorUtils.getCorPorNomeSp360('verde-limao-medio'))
      cores.push(CorUtils.getCorPorNomeSp360('amarelo-bistre-medio'))
      cores.push(CorUtils.getCorPorNomeSp360('azul-columbia-medio'))
      cores.push(CorUtils.getCorPorNomeSp360('azul-glauco-medio'))

      let sub = id ? _.find(this.dadosSegmentoEducacao.filaCreche, { 'id_subprefeitura': id }) : this.filaCrechecheGeral()
      this.chartEducacao.data = [{
        'grupo': this.$t('eixos.social.distribuicaoFilaCreche.deficitMenor1Ano'),
        'vagas': sub.bercario_i,
        'color': am4core.color(cores[0]),
      }, {
        'grupo': this.$t('eixos.social.distribuicaoFilaCreche.deficit1Ano'),
        'vagas': sub.bercario_ii,
        'color': am4core.color(cores[1]),
      }, {
        'grupo': this.$t('eixos.social.distribuicaoFilaCreche.deficit2Anos'),
        'vagas': sub.mini_grupo_i,
        'color': am4core.color(cores[2]),
      }, {
        'grupo': this.$t('eixos.social.distribuicaoFilaCreche.deficit3Anos'),
        'vagas': sub.mini_grupo_ii,
        'color': am4core.color(cores[3]),
      }]
    },
    // -- fim Segmento de Educação

    /** Metodos Segmento de Zeladoria
   */
    segmentZeladoriaUpdate (id) {
      this.populateTabelaServicos(id)
    },

    populateTabelaServicos (sub) {
      let redeSub = sub ? _.find(this.dadosSegmentoZeladoria.servicos156, { 'id': sub }) : this.dadosSegmentoZeladoria.servicos156[0]
      this.tabelaServicos.tableData.data = redeSub.servicos
    },
    // -- fim Segmento de Zeladoria

    /** Metodos Segmento de Demografia
   */
    segmentDemografiaUpdate (id) {
      this.populacaoMunicipal = this.dadosPolulacioniasRegionais(this.dadosSegmentoDemografia.populacao[0].dados)
      this.dadosGraficoDemografia = (id ? this.dadosSegmentoDemografia.populacao[id].dados : this.dadosSegmentoDemografia.populacao[0].dados)
      let x = this.dadosPolulacioniasRegionais(this.dadosGraficoDemografia)
      this.$refs.graficoRegional.carregamentoInicial(this.dadosGraficoDemografia)
    },

    dadosPolulacioniasRegionais (dados) {
      this.populacaoMasculina = 0
      this.populacaoFeminina = 0
      this.populacaoRegional = 0
      dados.forEach(e => {
        this.populacaoMasculina += e.masculino
        this.populacaoFeminina += e.feminino
        this.populacaoRegional += (e.feminino + e.masculino)
      })

      let a = MethGlob.arredondaPorcentagens([this.populacaoMasculina, this.populacaoFeminina, this.populacaoRegional], 0)
      let d = { m: this.populacaoMasculina, f: this.populacaoFeminina, t: this.populacaoRegional }

      return d
    },

    percentualPopulacional (valor, total) {
      let a = (valor / total) * 100
      return Math.round(a)
    },

    populacaoRegionalCard () {
      return MethGlob.formatarGrandesNumeros(this.populacaoRegional)
    },

    populacaoFemininaCard () {
      return MethGlob.formatarGrandesNumeros(this.populacaoFeminina)
    },

    populacaoMasculinaCard () {
      return MethGlob.formatarGrandesNumeros(this.populacaoMasculina)
    },

    // -- fim Segmento Demografia

    /**
    *  Metodos Segmento de Singularidades
    */

    segmentSingularidadesUpdate (id) {
      // this.$refs.imagens.setId(id)
      this.idSub = id
      this.dadosSingularidades = this.dadosSegmentoSingularidades['singularidades'][ id || 0 ]
    },
    // -- fim Segmento Singularidades

    /**
     *  Metodos Segmmento Assistencia Social
     */

    segmentAssistenciaUpdate (id) {
      const sub = _.find(this.dadosSegmentoAssistenciaSocial.dadosRegionalizados.massa, { 'id_subprefeitura': id || 0 })
      this.vagasPorServico(sub)
      this.assistenciaSocialCards(sub)
    },

    vagasPorServico (sub) {
      this.dadosSegmentoAssistenciaSocial.dadosRegionalizados.dados = sub.lista_tipo_servico
    },

    assistenciaSocialCards (sub) {
      this.dadosSegmentoAssistenciaSocial.cards.ocupacao = sub.percentual_medio_ocupacao + '%'
      this.dadosSegmentoAssistenciaSocial.cards.vagas = sub.total_vagas_contratadas
      // this.dadosSegmentoAssistenciaSocial.cards.populacao =  sub.total_vagas_femininas
    },

    // -- fim Segmento Assistencia Social
  },

}
</script>

<style lang="scss" scoped>
    .listas{
      overflow-y: scroll;
    }
    .oddCards{
      width: 20%;
    }
    .segmento{
       width: 70%;
    }
    .flex-box{
        display: flex;
        flex-direction: row;
        align-items: stretch;
        justify-content: space-around;
        &_item_chart {
          flex-grow: 3.02
        }
        &_item_cards {
          flex-grow: 1.97;
            display : flex;
            flex-direction: column;
            justify-content:space-between;
        }
    }
    #chartMatriculas{
        height: 52.5vh;
        width: 100%;
    }
    #chartOcupacaoAbrigos{
        height: 52.5vh;
        width: 100%;
    }
    #chartMedicamentos{
        height: 47vh;
    }
    .educacao{
        align-items: center;
        grid-area: educacao;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }
    .habitacao{
        grid-area: habitacao;
    }
    .saude{
        grid-area: saude;
        display:flex;
        flex-direction: row;
        justify-content: space-between;
    }
    #distritosMap{
        width: 30%;
    }
    #mapaSP{
        height: 30%;
        width: 30%;
    }
    #tabelaFilaExame{
        width: 40vw;
        height: 32vh;
    }
    #chartPopulacao{
        height: 25vh;
    }
    .multiselect{
        width: 20vw;
    }
    .chart{
      height: 30rem;
      max-height: 40rem;
    }
    #painel_singularidades{
      text-align: justify;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .flex.lg6{
        max-width: 48.7%;
      }
    }
    p {
      text-indent: 1.5em;
    }

    #img {
      margin-bottom: .5rem;
      border-radius: 0.375rem;
      border: none;
      box-shadow: 0 2px 3px 0 rgba(52, 56, 85, 0.25);
    }

    @media (max-width: 1000px) {
      #painel_singularidades .flex.lg6{
        max-width: 100%;
      }
    }
</style>

<style lang="scss" scoped>
@import "@/sass/_colors.scss";

$font-size : 1rem;

.tabelaRemedioCorIdeal {
    background-color: $azul-glauco-escuro !important;
    color: white;
     td {
          // border-style: solid;
          // border-width: 2px;
          // border-color: black;
          padding: 0.1rem;
          font-size: $font-size;
      }
}

.tabelaRemedioCorBom {
    background-color: $verde-medio !important;
    color: white;

  td {
        // border-style: solid;
        // border-width: 2px;
        // border-color: black;
        padding: 0.1rem;
        font-size: $font-size;
    }
}

.tabelaRemedioCorRegular {
    background-color: $amarelo-medio !important;
    color: $black;

  td {
        // border-style: solid;
        // border-width: 2px;
        // border-color: black;
        padding: 0.1rem;
        font-size: $font-size;
    }
}

.tabelaRemedioCorCritico {
    background-color: $vermelho-medio !important;
    color: white;

  td {
        // border-style: solid;
        // border-width: 2px;
        // border-color: black;
        padding: 0.1rem;
        font-size: $font-size;
    }
}

.slimCard{
  max-height: 10rem;
}

</style>

<style lang="scss" scoped>

.topCardGrid{
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(10vw, 1fr) );
}

.divComboTab{
    display: flex;
    flex-direction: row;
    flex: 0 1 auto;
    flex-grow: 1, 2;
    flex-wrap: wrap;
}
@media (max-width: 1370px)
{
  .va-tab {
  align-items: center;
  display: inline-flex;
  flex: 0 1 auto;
  font-weight: $font-weight-bold;
  line-height: normal;
  height: inherit;
  max-width: 264px;
  text-align: center;
  vertical-align: middle;

  padding: 0.4375rem 0.35rem; // 0.75rem
  font-weight: $font-weight-bold;
  cursor: pointer;

  &:not(.va-tab--active) {
    opacity: .5;
  }

  &__content {
    align-items: center;
    color: inherit;
    display: flex;
    flex: 1 1 auto;
    height: 100%;
    justify-content: center;
    max-width: inherit;
    text-decoration: none;
    transition: $transition-primary;
    user-select: none;
    white-space: normal;
  }

  .va-tab--disabled {
    .va-tab__container {
      @include va-disabled();
    }

    pointer-events: none;
    cursor: inherit;
  }
}
}

</style>
